import { moneyFromMajor, type Money } from '@expense-assistant/finance-core';

const PLAIN_MAJOR_AMOUNT = /^\d+(\.\d{1,2})?$/;

/**
 * Parses a raw text input into minor-unit money, or returns null when the
 * input is not a plain non-negative decimal with at most 2 fraction digits.
 * Never throws: callers use the null result to show validation feedback
 * instead of letting `moneyFromMajor` exceptions escape event handlers.
 */
export function parseMoneyInput(value: string): Money | null {
  const trimmed = value.trim();
  if (!PLAIN_MAJOR_AMOUNT.test(trimmed)) return null;
  try {
    return moneyFromMajor(trimmed);
  } catch {
    return null;
  }
}
